/* Cardboard Sports theme — small progressive enhancements. Everything works without JS. */
(function () {
  // Copy discount code buttons
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-copy-code]');
    if (!button) return;
    var code = button.getAttribute('data-copy-code');
    var label = button.querySelector('[data-copy-label]');
    var original = label ? label.textContent : '';
    var done = function () {
      if (!label) return;
      label.textContent = button.getAttribute('data-copied-label') || 'Copied!';
      setTimeout(function () { label.textContent = original; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {});
    }
  });

  // Close the mobile menu when a link inside it is chosen
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.mobile-nav__panel a');
    if (!link) return;
    var details = link.closest('details');
    if (details) details.removeAttribute('open');
  });
})();
